import { LoaderCircle } from "lucide-react"

export const LazyLoading = () => {
    return(
            <div className="font-vazir min-h-screen min-w-full flex justify-center items-center">
  <LoaderCircle color="#464646" className="animate-spin w-12 h-12 rounded-full" />
</div>
    )
}
